import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/huBei/phone1.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-0661a770")

_pushScopeId("data-v-0661a770")
const _hoisted_1 = { class: "info-container" }
const _hoisted_2 = { class: "head" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, "浏览次数", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, "浏览人数", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("span", null, "登记数", -1)
const _hoisted_6 = { class: "content" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "content-title" }, "登记情况", -1)
const _hoisted_8 = { class: "table" }
const _hoisted_9 = {
  class: "popup-content",
  style: {"padding":"0.36rem"}
}
const _hoisted_10 = /*#__PURE__*/_createVNode("div", {
  class: "title",
  style: {"text-align":"center","font-size":"0.34rem","font-weight":"bold","color":"#222"}
}, " 登记详情 ", -1)
const _hoisted_11 = {
  class: "title-name",
  style: {"display":"flex","justify-content":"space-between","align-items":"center","padding":"0.4rem 0 0.36rem 0","font-size":"0.28rem","color":"#222","border-bottom":"1px solid #e9e9e9"}
}
const _hoisted_12 = { style: {"width":"3.84rem","white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"} }
const _hoisted_13 = { style: {"padding-left":"0.47rem","color":"#828282"} }
const _hoisted_14 = { style: {"padding-left":"0.54rem","font-weight":"bold"} }
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { style: {"font-size":"0.12rem"} }, "￥", -1)
const _hoisted_16 = {
  class: "user-content",
  style: {"padding":"0.35rem 0 0.5rem 0","font-size":"0.28rem"}
}
const _hoisted_17 = /*#__PURE__*/_createVNode("div", {
  class: "title",
  style: {"font-weight":"bold","color":"#222"}
}, "用户信息", -1)
const _hoisted_18 = {
  class: "user-content-item",
  style: {"display":"flex","padding-top":"0.3rem"}
}
const _hoisted_19 = /*#__PURE__*/_createVNode("span", { style: {"width":"1.5rem","color":"#979797"} }, "姓名", -1)
const _hoisted_20 = { style: {"color":"#393939"} }
const _hoisted_21 = {
  class: "user-content-item",
  style: {"display":"flex","padding-top":"0.3rem"}
}
const _hoisted_22 = /*#__PURE__*/_createVNode("span", { style: {"width":"1.5rem","color":"#979797"} }, "手机号", -1)
const _hoisted_23 = { style: {"color":"#393939"} }
const _hoisted_24 = /*#__PURE__*/_createVNode("img", {
  style: {"width":"0.26rem","height":"0.34rem","margin-left":"0.18rem"},
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_25 = {
  class: "user-content-item",
  style: {"display":"flex","padding-top":"0.3rem"}
}
const _hoisted_26 = /*#__PURE__*/_createVNode("span", { style: {"width":"1.5rem","color":"#979797"} }, "身份证号", -1)
const _hoisted_27 = { style: {"color":"#393939"} }
const _hoisted_28 = {
  class: "user-content-item",
  style: {"display":"flex","padding-top":"0.3rem"}
}
const _hoisted_29 = /*#__PURE__*/_createVNode("span", { style: {"width":"1.5rem","color":"#979797"} }, "家庭地址", -1)
const _hoisted_30 = { style: {"color":"#393939","flex":"1"} }
const _hoisted_31 = {
  class: "btn",
  style: {"display":"flex","justify-content":"center"}
}
const _hoisted_32 = /*#__PURE__*/_createTextVNode("删除用户")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_vxe_column = _resolveComponent("vxe-column")
  const _component_vxe_table = _resolveComponent("vxe-table")
  const _component_van_button = _resolveComponent("van-button")
  const _component_van_popup = _resolveComponent("van-popup")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", null, [
          _createVNode("span", null, _toDisplayString(_ctx.detail.viewCount), 1),
          _hoisted_3
        ]),
        _createVNode("div", null, [
          _createVNode("span", null, _toDisplayString(_ctx.detail.visitorCount), 1),
          _hoisted_4
        ]),
        _createVNode("div", null, [
          _createVNode("span", null, _toDisplayString(_ctx.detail.registrationCount || 0), 1),
          _hoisted_5
        ])
      ]),
      _createVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode("div", _hoisted_8, [
          _createVNode(_component_vxe_table, {
            align: "center",
            data: _ctx.detail.servingRegistrationList,
            border: "full",
            onCellClick: _ctx.onClickCell
          }, {
            default: _withId(() => [
              _createVNode(_component_vxe_column, {
                field: "servingName",
                title: "服务包",
                width: "31%"
              }),
              _createVNode(_component_vxe_column, {
                field: "userName",
                title: "姓名",
                width: "20%"
              }),
              _createVNode(_component_vxe_column, {
                field: "servingPriceSum",
                title: "金额",
                width: "18%"
              }),
              _createVNode(_component_vxe_column, {
                field: "createTime",
                title: "提交时间"
              })
            ]),
            _: 1
          }, 8, ["data", "onCellClick"])
        ])
      ])
    ]),
    _createVNode(_component_van_popup, {
      show: _ctx.show,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => (_ctx.show = $event)),
      position: "bottom",
      closeable: "",
      teleport: ".service-info-container",
      style: {"border-radius":"0.24rem 0.24rem 0 0"}
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode("div", _hoisted_11, [
            _createVNode("span", _hoisted_12, _toDisplayString(_ctx.currentDetail.servingName), 1),
            _createVNode("span", _hoisted_13, "共" + _toDisplayString(_ctx.currentDetail.servingCount) + "份", 1),
            _createVNode("span", _hoisted_14, [
              _hoisted_15,
              _createTextVNode(_toDisplayString(_ctx.currentDetail.servingPriceSum), 1)
            ])
          ]),
          _createVNode("div", _hoisted_16, [
            _hoisted_17,
            _createVNode("div", _hoisted_18, [
              _hoisted_19,
              _createVNode("span", _hoisted_20, _toDisplayString(_ctx.currentDetail.userName), 1)
            ]),
            _createVNode("div", _hoisted_21, [
              _hoisted_22,
              _createVNode("div", {
                style: {"display":"flex","align-items":"center"},
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.callPhone(_ctx.currentDetail.phone)))
              }, [
                _createVNode("span", _hoisted_23, _toDisplayString(_ctx.currentDetail.phone), 1),
                _hoisted_24
              ])
            ]),
            _createVNode("div", _hoisted_25, [
              _hoisted_26,
              _createVNode("span", _hoisted_27, _toDisplayString(_ctx.currentDetail.identityCard), 1)
            ]),
            _createVNode("div", _hoisted_28, [
              _hoisted_29,
              _createVNode("span", _hoisted_30, _toDisplayString(_ctx.currentDetail.province +
            _ctx.currentDetail.city +
            _ctx.currentDetail.district +
            _ctx.currentDetail.address), 1)
            ])
          ]),
          _createVNode("div", _hoisted_31, [
            _createVNode(_component_van_button, {
              type: "primary",
              plain: "",
              style: {"width":"2.3rem","height":"0.68rem","border":"2px solid #ff931f","border-radius":"0.34rem","font-size":"0.28rem","color":"#222"},
              onClick: _ctx.delUser
            }, {
              default: _withId(() => [
                _hoisted_32
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
})